import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import "@/index.css";
import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import AuthCallback from "@/pages/AuthCallback";
import SharedSound from "@/pages/SharedSound";
import SharedVideo from "@/pages/SharedVideo";

function AppRouter() {
  const location = useLocation();
  // Handle OAuth callback synchronously during render to avoid race conditions
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/s/:shareId" element={<SharedSound />} />
      <Route path="/v/:shareId" element={<SharedVideo />} />
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <LanguageProvider>
          <AuthProvider>
            <AppRouter />
            <Toaster
              theme="dark"
              position="bottom-right"
              toastOptions={{
                style: {
                  background: "#121216",
                  border: "1px solid #272730",
                  color: "#fff",
                  fontFamily: "Manrope, sans-serif",
                },
              }}
            />
          </AuthProvider>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}
